export const STEPS = {
  WALLET_INPUT: 'WALLET_INPUT',
  SCREENING_FAILED: 'SCREENING_FAILED',
  AMOUNT_INPUT: 'AMOUNT_INPUT',
  SUCCESS: 'SUCCESS',
};

export const ACTIONS = {
  SET_WALLET_ADDRESS: 'SET_WALLET_ADDRESS',
  SET_NETWORK: 'SET_NETWORK',
  SET_CONFIRMED: 'SET_CONFIRMED',
  SET_AMOUNT: 'SET_AMOUNT',
  SET_IS_MAX_AMOUNT: 'SET_IS_MAX_AMOUNT',
  SET_WALLET_SCREENING_SUBMITTING: 'SET_WALLET_SCREENING_SUBMITTING',
  SET_WALLET_SCREENING_ERROR: 'SET_WALLET_SCREENING_ERROR',
  SET_SUBMITTING: 'SET_SUBMITTING',
  SET_ERROR: 'SET_ERROR',
  GO_TO_STEP: 'GO_TO_STEP',
  RESET: 'RESET',
};

export const INITIAL_STATE = {
  step: STEPS.WALLET_INPUT,
  walletAddress: '',
  network: '',
  isConfirmed: false,
  amount: '',
  isMaxAmount: false,
  isWalletScreeningSubmitting: false,
  walletScreeningError: null,
  isSubmitting: false,
  error: null,
};

export const NETWORK_OPTIONS = [{ value: 'SUI', label: 'SUI' }];
